export const googleAnalytic = (action, category, label) => {
    let tryToDrapGA = () => {
        if (window && window.gtag) {
            dropGA(action, category, label);
        } else {
            setTimeout(() => tryToDrapGA(), 500);
        }
    };

    tryToDrapGA();
};

const isDebug = () => {
    if (window && window.globalPageData && window.globalPageData.analytics) {
        return window.globalPageData.analytics.debug === true;
    }
    return false;
};

const dropGA = (eventAction, category, eventLabel) => {
    if (isDebug()) {
        console.log('GA Event FIRED:', eventAction, {
            event_category: category,
            event_label: eventLabel,
            value: 1,
        });
    }

    window.gtag('event', eventAction, {
        event_category: category,
        event_label: eventLabel,
        value: 1,
    });
};
